<div id="navigation-header">
  <div class="sectional-navigation">
    <ul>
      <li routerLinkActive="current">
        <a class="nav-circle" routerLink="/centigrade/course-areas" [class.disabled]="!questionnaireComplete">
          <div class="circle">1</div><div class="text">{{locale.courseAreasItemText}}</div>
        </a>
      </li>
      <li routerLinkActive="current">
        <a class="nav-circle" routerLink="/centigrade/course-area-filters" [class.disabled]="!courseAreasComplete">
          <div class="circle">2</div><div class="text">{{locale.filtersItemText}}</div>
        </a>
      </li>
      <li routerLinkActive="current">
        <a class="nav-circle" routerLink="/centigrade/courses/list" [class.disabled]="!preferencesComplete">
          <div class="circle">3</div><div class="text">{{locale.coursesItemText}}</div>
        </a>
      </li>
      <li routerLinkActive="current">
        <a class="nav-circle" routerLink="/centigrade/courses/shortlist" [class.disabled]="!coursesComplete">
          <div class="circle">4</div><div class="text">{{locale.shortlistItemText}}</div>
        </a>
      </li>
      <li routerLinkActive="current">
        <a class="nav-circle" routerLink="/centigrade/personal-statement-questions/main" [class.disabled]="!coursesComplete">
          <div class="circle">5</div><div class="text">{{locale.personalStatementText}}</div>
        </a>
      </li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-nav/main-nav.component.html